import { Map } from "ol";
import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import Point from "ol/geom/Point";
import { NauticalWarningItemDto } from "~/api/GeneratedApi";
import { LayerTitle } from "../types/layers";
import { CustomMapEventTypes } from "../types/map";
import { nauticalWarningToMapItem } from "./dataConverters";
import { findSourceByTitle } from "./findSourceByTitle";

export function addNauticalWarningsToMap(
  map: Map,
  NauticalWarnings: NauticalWarningItemDto[],
): void {
  const source = findSourceByTitle(map, LayerTitle.NauticalWarnings);
  // Clear the source before adding
  source.clear();
  const features: Feature<Geometry>[] = [];
  NauticalWarnings.forEach((e) => {
    // Convert to internal type
    const convertedNauticalWarning = nauticalWarningToMapItem(e);
    if (!e.location) return;
    const transformed = [e.location.x, e.location.y];
    const point = new Point(transformed);
    const feat = new Feature({
      geometry: point,
    });
    feat.setProperties({ ...convertedNauticalWarning });
    feat.set("overlayOffsetY", -24);
    feat.setId(convertedNauticalWarning.mapId);
    features.push(feat);
  });
  source.addFeatures(features);
  source.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
  map.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
}
